<!--
	Copyright (c) 2017-present, flop! contributors
	SPDX-License-Identifier: AGPL-3.0-or-later
	https://framagit.org/flopedt/flopedt
-->

<script setup lang="ts">
import type { RouteRecordNameGeneric } from 'vue-router'

import Row from '@uikit/layout/Row.vue'

defineProps<{ to: RouteRecordNameGeneric }>()
defineSlots<{ default: () => unknown }>()
</script>

<template>
  <Row as-child alignment="center" :gap="2">
    <RouterLink :to="{ name: to }" exact-active-class="active" class="nav-item">
      <slot />
    </RouterLink>
  </Row>
</template>

<style scoped>
.nav-item {
  color: var(--color-text-secondary);
  text-decoration: none;
  font-weight: 600;
}

.nav-item :deep(svg) {
  height: 1.125em;
  width: 1.125em;
}

.nav-item.active {
  color: var(--color-text-accent);
}
</style>
